module.exports = "mat-card {\n  width: 50%;\n  margin: 20px auto; }\n  mat-cardimg {\n    width: 200px;\n    height: 200px; }\n"